import { render, staticRenderFns } from "./ExpandableTextarea.vue?vue&type=template&id=6a75c71a&scoped=true&"
import script from "./ExpandableTextarea.vue?vue&type=script&lang=js&"
export * from "./ExpandableTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableTextarea.vue?vue&type=style&index=0&id=6a75c71a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75c71a",
  null
  
)

export default component.exports